<div class="widget-container">
  <div class="row" *ngIf="isLoggedIn">
    <div class="col-4 p-0" style="border-right: 1px solid #E8EAEE;">
      <app-secure-mail  [pageType]="'fullscreen'" class="mail-pane" (mailSelected)="onMailSelected($event)"
        (isNewMailOpened)="openNewMail()">
      </app-secure-mail>
    </div>

    <div class="col-8" style="max-height:calc(100vh - 100px);max-height:calc(100dvh - 100px);overflow-y:auto;margin-left: -12px;margin-right:-10px">
      <app-mail-popup *ngIf="isNewMailOpen" [pageType]="'fullscreen'" class="preview-pane"></app-mail-popup>

      <app-preview-mail 
        *ngIf="pageType === 'fullscreen' && selectedMail && !isNewMailOpen" 
        [emailId]="selectedMail?.id"
        [pageType]="'fullscreen'"
        class="preview-pane"
      >
      </app-preview-mail>
    </div>
  </div>
</div>